import { useState } from "react";

/**
 * Saltie Wink™ butterfly — OFFICIAL BRAND ASSET.
 *
 * Drop the official artwork at one of these paths and it will be used automatically:
 *   /app/frontend/public/saltie-wink.png   (preferred)
 *   /app/frontend/public/saltie-wink.svg
 *   /app/frontend/public/saltie-wink.webp
 *
 * Until the official artwork is uploaded, a placeholder using the brand
 * palette (pink + yellow) is shown — it is intentionally simple and never
 * meant to replace the official Saltie Wink.
 */
const CANDIDATES = ["/saltie-wink.png", "/saltie-wink.svg", "/saltie-wink.webp"];

export function Butterfly({ size = 36, className = "" }) {
  const [idx, setIdx] = useState(0);
  const [failed, setFailed] = useState(false);

  if (failed) {
    // Placeholder ONLY — to be replaced by the official Saltie Wink artwork.
    return (
      <svg
        viewBox="0 0 60 50"
        style={{ width: size, height: size * (50 / 60) }}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Saltie Wink placeholder"
      >
        <g className="wing-flutter">
          <path d="M30 25 C 14 6, 2 8, 6 25 C 2 36, 14 40, 30 28 Z" fill="#D62839" opacity="0.92" />
          <path d="M30 25 C 46 6, 58 8, 54 25 C 58 36, 46 40, 30 28 Z" fill="#C8A876" opacity="0.92" />
          <circle cx="14" cy="20" r="2" fill="#4B3A2F" opacity="0.8" />
          <circle cx="46" cy="20" r="2" fill="#4B3A2F" opacity="0.8" />
        </g>
        <ellipse cx="30" cy="26" rx="1.2" ry="9" fill="#3E2723" />
        <circle cx="30" cy="18" r="2" fill="#3E2723" />
      </svg>
    );
  }

  return (
    <img
      src={CANDIDATES[idx]}
      alt="Saltie Wink"
      style={{ width: size, height: "auto" }}
      className={`select-none pointer-events-none saltie-wink-flutter ${className}`}
      onError={() => {
        if (idx < CANDIDATES.length - 1) setIdx(idx + 1);
        else setFailed(true);
      }}
    />
  );
}

export default function Butterflies({ gutters = false }) {
  // Ambient Saltie Wink™ butterflies drifting across the page. Kept sparse
  // so they feel "discovered, not decorative" (per the IP Bible), but with
  // five varied drift paths so there is nearly always one on screen.
  // `gutters` keeps them in the side margins, behind page content.
  return (
    <div
      aria-hidden="true"
      data-testid={gutters ? "butterflies-gutters" : "butterflies"}
      className={`pointer-events-none fixed inset-0 z-30 overflow-hidden ${gutters ? "butterflies-gutters" : ""}`}
    >
      <div className="butterfly-1 absolute">
        <Butterfly size={54} />
      </div>
      <div className="butterfly-2 absolute">
        <Butterfly size={46} />
      </div>
      <div className="butterfly-3 absolute">
        <Butterfly size={40} />
      </div>
      <div className="butterfly-4 absolute">
        <Butterfly size={48} />
      </div>
      <div className="butterfly-5 absolute">
        <Butterfly size={42} />
      </div>
      <div className="butterfly-6 absolute">
        <Butterfly size={38} />
      </div>
    </div>
  );
}
